import { render, staticRenderFns } from "./MenuNotification.vue?vue&type=template&id=19cb7a35"
import script from "./MenuNotification.vue?vue&type=script&lang=js"
export * from "./MenuNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports